import { render, staticRenderFns } from "./LandChangesDetails.vue?vue&type=template&id=783a44bc&scoped=true&"
import script from "./LandChangesDetails.vue?vue&type=script&lang=js&"
export * from "./LandChangesDetails.vue?vue&type=script&lang=js&"
import style0 from "./LandChangesDetails.vue?vue&type=style&index=0&id=783a44bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a44bc",
  null
  
)

export default component.exports